/* eslint-disable no-underscore-dangle */
/* eslint-disable prefer-promise-reject-errors */
import { createStore, applyMiddleware, compose } from 'redux';
import ReduxThunk from 'redux-thunk';
import { offline } from '@redux-offline/redux-offline';

import { api } from '@breezeway/brzw-react-core';
import {
  asyncCallbacksMiddleware,
  authMiddleware,
  googleAnalytics,
  maintenanceMiddleware,
  offlineConfig,
  socketMiddleware,
  transformAxiosPayloadMiddleware,
  versionGuardMiddleware,
} from './redux-middlewares';
import reducer from './root_reducer';

const { apiMiddleware } = api;

const configureStore = () => {
  const applyFunc = applyMiddleware(
    googleAnalytics,
    authMiddleware,
    apiMiddleware,
    transformAxiosPayloadMiddleware,
    asyncCallbacksMiddleware,
    ReduxThunk,
    maintenanceMiddleware,
    versionGuardMiddleware,
    socketMiddleware,
  );
  const composeFunc =
    process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION__
      ? compose(
          applyFunc,
          window.__REDUX_DEVTOOLS_EXTENSION__(),
        )
      : applyFunc;
  const store = createStore(reducer, composeFunc, offline(offlineConfig));

  if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./root_reducer', () => {
      const reducers = require('./root_reducer').default; // eslint-disable-line global-require
      store.replaceReducer(reducers);
    });
  }

  return store;
};

export default configureStore;
